import React from "react";

type ToastProps = {
  message: string;
  type?: string;
  onClose: () => void;
};

const Toast: React.FC<ToastProps> = ({ message, type, onClose }) => {

  const toastClass =
    type === "info" ? "toast--success" : "toast--error";

  return (
    <div
      className="toast-container position-fixed top-0 end-0 p-3"
      style={{ zIndex: 1055 }}
    >
      <div
        className={`toast show align-items-center ${toastClass}`}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="d-flex">
          <div className="toast-body">
            {message}
          </div>
          <button
            type="button"
            className="btn-close me-2 m-auto"
            aria-label="Close"
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default Toast;
